import type { PropsWithChildren } from 'react';

export interface PositionProps extends PropsWithChildren {
  index?: number;
  flex?: number;
}
